import { render } from "./ExamPaper.vue?vue&type=template&id=1efd0d18&ts=true"
import script from "./ExamPaper.vue?vue&type=script&lang=ts"
export * from "./ExamPaper.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__